var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valttikorttiData)?_c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.localStorage.translations.pages['setting-personal_area'].sections['valttikortti'],"data":[
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya'],
      value: _vm.dateEndFormatted || '-',
    },
  ],"images":_vm.valttikorttiData.image ? [_vm.valttikorttiData.image] : null,"need-image-domain":"","editReady":_vm.editReady}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }